import type { PropsWithChildren } from "react";


export function Broken({ children }: PropsWithChildren) {
  return children;
}
